<template>
  <div class="exp-wrap">
    <p class="title">工作经历</p>
    <div class="table-box">
      <Form :model="formData" ref="formDynamic">
        <Table :columns="columns" :data="formData.tableData">
          <!-- 时间区间 -->
          <template slot-scope="{ index, row }" slot="dateAround">
            <Form-item :prop="'tableData.' + index + '.dateAround'" :rules="$units.formRule.arrRequired('请选择时间区间')">
              <DatePicker
                transfer
                v-model="formData.tableData[index].dateAround"
                format="yyyy-MM-dd"
                type="daterange"
                placeholder="请选择时间区间"
              ></DatePicker>
            </Form-item>
          </template>
          <!-- 单位名称 -->
          <template slot-scope="{ index }" slot="company">
            <Form-item :prop="'tableData.' + index + '.company'" :rules="{ required: true, message: '请输入单位名称', trigger: 'blur' }">
              <Input v-model="formData.tableData[index].company" placeholder="请输入单位名称" />
            </Form-item>
          </template>
          <!-- 部门职位 -->
          <template slot-scope="{ index }" slot="position">
            <Form-item :prop="'tableData.' + index + '.position'" :rules="{ required: true, message: '请输入部门职位', trigger: 'blur' }">
              <Input v-model="formData.tableData[index].position" placeholder="请输入部门职位" />
            </Form-item>
          </template>
          <!-- 操作 -->
          <template slot-scope="{ index }" slot="action">
            <span class="table-btn" @click="del(1, index)">删除</span>
          </template>
        </Table>
      </Form>
      <Button type="primary" @click="addExp(1)">+ 增加</Button>
    </div>

    <p class="title">教育经历</p>
    <div class="table-box">
      <Form :model="formData" ref="formDynamic1">
        <Table :columns="columns1" :data="formData.tableData1">
          <!-- 时间区间 -->
          <template slot-scope="{ index, row }" slot="dateAround">
            <Form-item :prop="'tableData1.' + index + '.dateAround'" :rules="$units.formRule.arrRequired('请选择时间区间')">
              <DatePicker
                transfer
                v-model="formData.tableData1[index].dateAround"
                format="yyyy-MM-dd"
                type="daterange"
                placeholder="请选择时间区间"
              ></DatePicker>
            </Form-item>
          </template>
          <!-- 部门职位 -->
          <template slot-scope="{ index }" slot="school">
            <Form-item :prop="'tableData1.' + index + '.school'" :rules="{ required: true, message: '请输入学校名称', trigger: 'blur' }">
              <Input v-model="formData.tableData1[index].school" placeholder="请输入学校名称" />
            </Form-item>
          </template>
          <!-- 部门职位 -->
          <template slot-scope="{ index }" slot="specialty">
            <Form-item :prop="'tableData1.' + index + '.specialty'" :rules="{ required: true, message: '请输入专业名称', trigger: 'blur' }">
              <Input v-model="formData.tableData1[index].specialty" placeholder="请输入专业名称" />
            </Form-item>
          </template>
          <!-- 部门职位 -->
          <template slot-scope="{ index }" slot="level">
            <Form-item :prop="'tableData1.' + index + '.level'" :rules="{ required: true, message: '请选择对应学历', trigger: 'change',type:'number' }">
              <Select v-model="formData.tableData1[index].level" transfer placeholder="请选择对应学历" clearable>
                <Option :value="1">初中</Option>
                <Option :value="2">中专</Option>
                <Option :value="3">高中</Option>
                <Option :value="4">大专</Option>
                <Option :value="5">本科</Option>
                <Option :value="6">硕士</Option>
                <Option :value="7">博士</Option>
              </Select>
            </Form-item>
          </template>
          <template slot-scope="{ index }" slot="action">
            <span class="table-btn" @click="del(2, index)">删除</span>
          </template>
        </Table>
      </Form>
      <Button type="primary" @click="addExp(2)">+ 增加</Button>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
export default {
  data() {
    return {
      formData: {
        tableData: [],
        tableData1: []
      },
      userId: '', //业务员id
      columns: [
        {
          title: '时间区间',
          slot: 'dateAround',
          minWidth: 140,
          align: 'center'
        },
        {
          title: '单位名称',
          slot: 'company',
          align: 'center',
          minWidth: 140
        },
        {
          title: '部门职位',
          slot: 'position',
          align: 'center',
          minWidth: 140
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: '100'
        }
      ],
      columns1: [
        {
          title: '时间区间',
          slot: 'dateAround',
          minWidth: 140,
          align: 'center'
        },
        {
          title: '毕业学校',
          slot: 'school',
          align: 'center',
          minWidth: 140
        },
        {
          title: '所学专业',
          slot: 'specialty',
          align: 'center',
          minWidth: 140
        },
        {
          title: '学历', //1-初中、2-中专、3-高中、4-大专、5-本科、6-硕士、7-博士"
          slot: 'level',
          align: 'center',
          minWidth: 140
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: '100'
        }
      ]
    };
  },
  mounted() {
    this.userId = this.$route.query.userId;
  },
  methods: {
    async setData() {
      this.getUserWorkRecord();
      this.getUserEducationRecord();
    },
    addExp(type) {
      if (type == 1) {
        this.formData.tableData.push({});
      } else {
        this.formData.tableData1.push({});
      }
    },
    del(type, i) {
      if (type == 1) {
        this.formData.tableData.splice(i, 1);
      } else {
        this.formData.tableData1.splice(i, 1);
      }
    },
    getUserWorkRecord() {
      this.$http({
        type: 'GET',
        url: '/buz/userWorkRecord/read/list',
        data: {
          userId: this.userId
        }
      }).then(res => {
        this.formData.tableData = res.data.data.map(item => {
          item.dateAround = [item.beginTime, item.endTime];
          return item;
        });
      });
    },
    getUserEducationRecord() {
      this.$http({
        type: 'GET',
        url: '/buz/userEducationRecord/read/list',
        data: {
          userId: this.userId
        }
      }).then(res => {
        this.formData.tableData1 = res.data.data.map(item => {
          item.dateAround = [item.beginTime, item.endTime];
          return item;
        });
      });
    },
    save() {
      return new Promise(async (resolve, reject) => {
        // await this.saveUserWorkRecord();
        // await this.saveUserEducationRecord();
        Promise
          .all([this.saveUserWorkRecord(), this.saveUserEducationRecord()])
          .then(res => {
            resolve(res);
          })
          .catch(res => {
            reject({ page: 'experience', showMsg: true });
          });
      });
    },
    saveUserEducationRecord() {
      let arr = this.formData.tableData1.map(item => {
        if (item.dateAround) {
          item.beginTime = dayjs(item.dateAround[0]).format('YYYY-MM-DD');
          item.endTime = dayjs(item.dateAround[1]).format('YYYY-MM-DD');
          // delete item.dateAround;
        }
        return item;
      });
      return new Promise((resolve, reject) => {
        this.$refs.formDynamic1.validate().then(isok => {
          if (!isok) {
            reject({ page: 'experience', showMsg: true });
            return;
          }
          this.$http({
            type: 'POST',
            url: '/buz/userEducationRecord/save',
            data: {
              userId: this.userId,
              dataList: arr
            }
          })
            .then(res => {
              resolve(res);
            })
            .catch(res => {
              reject({ page: 'experience' });
            });
        });
      });
    },
    saveUserWorkRecord() {
      let arr = this.formData.tableData.map(item => {
        if (item.dateAround) {
          item.beginTime = dayjs(item.dateAround[0]).format('YYYY-MM-DD');
          item.endTime = dayjs(item.dateAround[1]).format('YYYY-MM-DD');
          // delete item.dateAround;
        }
        return item;
      });
      return new Promise((resolve, reject) => {
        this.$refs.formDynamic.validate().then(isok => {
          if (!isok) {
            reject({ page: 'experience', showMsg: true });
            return;
          }
          this.$http({
            type: 'POST',
            url: '/buz/userWorkRecord/save',
            data: {
              userId: this.userId,
              dataList: arr
            }
          })
            .then(res => {
              resolve(res);
            })
            .catch(res => {
              reject({ page: 'experience' });
            });
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.exp-wrap {
  padding-bottom: 20px;
}
.title {
  font-weight: 600;
  padding: 10px 0;
}

.ivu-form-item {
  margin-bottom: 0;
}
</style>